"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberingListType = void 0;
/**
 *  Enum used to control the different types of numbering list
 */
var NumberingListType;
(function (NumberingListType) {
    /**
     * Minimum value of the enum
     */
    NumberingListType[NumberingListType["Min"] = 1] = "Min";
    /**
     * Numbering triggered by 1.
     */
    NumberingListType[NumberingListType["Decimal"] = 1] = "Decimal";
    /**
     * Numbering triggered by 1-
     */
    NumberingListType[NumberingListType["DecimalDash"] = 2] = "DecimalDash";
    /**
     * Numbering triggered by 1)
     */
    NumberingListType[NumberingListType["DecimalParenthesis"] = 3] = "DecimalParenthesis";
    /**
     * Numbering triggered by (1)
     */
    NumberingListType[NumberingListType["DecimalDoubleParenthesis"] = 4] = "DecimalDoubleParenthesis";
    /**
     * Numbering triggered by a.
     */
    NumberingListType[NumberingListType["LowerAlpha"] = 5] = "LowerAlpha";
    /**
     * Numbering triggered by a)
     */
    NumberingListType[NumberingListType["LowerAlphaParenthesis"] = 6] = "LowerAlphaParenthesis";
    /**
     * Numbering triggered by (a)
     */
    NumberingListType[NumberingListType["LowerAlphaDoubleParenthesis"] = 7] = "LowerAlphaDoubleParenthesis";
    /**
     * Numbering triggered by a-
     */
    NumberingListType[NumberingListType["LowerAlphaDash"] = 8] = "LowerAlphaDash";
    /**
     * Numbering triggered by A.
     */
    NumberingListType[NumberingListType["UpperAlpha"] = 9] = "UpperAlpha";
    /**
     * Numbering triggered by A)
     */
    NumberingListType[NumberingListType["UpperAlphaParenthesis"] = 10] = "UpperAlphaParenthesis";
    /**
     * Numbering triggered by (A)
     */
    NumberingListType[NumberingListType["UpperAlphaDoubleParenthesis"] = 11] = "UpperAlphaDoubleParenthesis";
    /**
     * Numbering triggered by A-
     */
    NumberingListType[NumberingListType["UpperAlphaDash"] = 12] = "UpperAlphaDash";
    /**
     * Numbering triggered by i.
     */
    NumberingListType[NumberingListType["LowerRoman"] = 13] = "LowerRoman";
    /**
     * Numbering triggered by i)
     */
    NumberingListType[NumberingListType["LowerRomanParenthesis"] = 14] = "LowerRomanParenthesis";
    /**
     * Numbering triggered by (i)
     */
    NumberingListType[NumberingListType["LowerRomanDoubleParenthesis"] = 15] = "LowerRomanDoubleParenthesis";
    /**
     * Numbering triggered by i-
     */
    NumberingListType[NumberingListType["LowerRomanDash"] = 16] = "LowerRomanDash";
    /**
     * Numbering triggered by I.
     */
    NumberingListType[NumberingListType["UpperRoman"] = 17] = "UpperRoman";
    /**
     * Numbering triggered by I)
     */
    NumberingListType[NumberingListType["UpperRomanParenthesis"] = 18] = "UpperRomanParenthesis";
    /**
     * Numbering triggered by (I)
     */
    NumberingListType[NumberingListType["UpperRomanDoubleParenthesis"] = 19] = "UpperRomanDoubleParenthesis";
    /**
     * Numbering triggered by I-
     */
    NumberingListType[NumberingListType["UpperRomanDash"] = 20] = "UpperRomanDash";
    /**
     * Maximum value of the enum
     */
    NumberingListType[NumberingListType["Max"] = 20] = "Max";
})(NumberingListType = exports.NumberingListType || (exports.NumberingListType = {}));
//# sourceMappingURL=NumberingListType.js.map